import { render } from "./OnboardingProcess.vue?vue&type=template&id=79d01863&scoped=true"
import script from "./OnboardingProcess.vue?vue&type=script&lang=js"
export * from "./OnboardingProcess.vue?vue&type=script&lang=js"

import "./OnboardingProcess.vue?vue&type=style&index=0&id=79d01863&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d01863"]])

export default __exports__